import { cn } from '@/lib/utils'
import type { TicketStatus } from '@/types/ticket'

const SIZES = {
  sm: 'h-1.5 w-1.5',
  md: 'h-2 w-2',
} as const

const FILLS: Record<TicketStatus, string> = {
  open: 'bg-status-open',
  in_progress: 'bg-status-in-progress',
  pending: 'bg-status-pending',
  resolved: 'bg-status-resolved',
  closed: 'border border-status-resolved bg-transparent',
}

export function StatusDot({
  status,
  size = 'sm',
  className,
}: {
  status: TicketStatus
  size?: keyof typeof SIZES
  className?: string
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-block rounded-full transition-colors duration-180',
        SIZES[size],
        FILLS[status],
        className,
      )}
    />
  )
}
